import { Fragment, useEffect, useState } from "react";
import Footer from "../Component/Footer";
import Nav from "../Component/Nav";
import SideBar from "./partials/SideBar";
import API from "../Network/API";
import { Link } from "react-router-dom";

function Dashboard() {
  const [courses, setCourse] = useState([]);
  const [dashboard, setDashboard] = useState(0);
  const [events, setEvent] = useState([]);
  const [order, setOrder] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    API.get(`/dashboard`).then((response) => {
      setDashboard(response.data.data.total_purchased);
      setOrder(response.data.data.order_history);
      setCourse(response.data.data.on_going_course);
      setLoading(false);
    });

    API.get(`/events`).then((response) => {
      setEvent(response.data.data);
    });
  }, []);

  return (
    <Fragment>
      <Nav />
      <div className="studentDashboard">
        <div className="padding">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-3">
                <div className="DashboardSideBar">
                  <SideBar />
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="StudentDashboardContent">
                  <div className="dashboardHeader">
                    <span className="dashboardWelcome">Welcome back to</span>
                    <h4 className="dashboardTitle">Student Dashboard</h4>
                  </div>

                  {/* Stat cards */}
                  <div className="row g-3 mb-4">
                    <div className="col-12 col-sm-6">
                      <div className="statCard statCard--green">
                        <div className="statCardIcon">
                          <i className="fas fa-graduation-cap" />
                        </div>
                        <p className="statCardLabel">Total Purchased Courses</p>
                        <h2 className="statCardValue">{dashboard ?? 0}</h2>
                        <Link className="statCardLink" to="/my-courses">
                          View List <i className="fas fa-arrow-right" />
                        </Link>
                      </div>
                    </div>
                    <div className="col-12 col-sm-6">
                      <div className="statCard statCard--blue">
                        <div className="statCardIcon">
                          <i className="fas fa-chalkboard-teacher" />
                        </div>
                        <p className="statCardLabel">Instructors Subscribing</p>
                        <h2 className="statCardValue">{dashboard ?? 0}</h2>
                        <a className="statCardLink" href="#!">
                          View List <i className="fas fa-arrow-right" />
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* Ongoing courses */}
                  <div className="sectionHeader">
                    <h6 className="sectionTitle">Ongoing Courses</h6>
                    <Link className="sectionLink" to="/my-courses">
                      See all
                    </Link>
                  </div>
                  <div className="row g-3 mb-4">
                    {loading &&
                      [0, 1].map((n) => (
                        <div className="col-12 col-sm-6" key={n}>
                          <div className="courseCard courseCard--skeleton" />
                        </div>
                      ))}

                    {!loading && courses?.length === 0 && (
                      <div className="col-12">
                        <div className="emptyState">
                          <i className="fas fa-book-open" />
                          <p>You have no ongoing courses yet.</p>
                        </div>
                      </div>
                    )}

                    {!loading &&
                      courses?.map((course, index) => (
                        <div className="col-12 col-sm-6" key={index}>
                          <div className="courseCard">
                            <div className="courseCardTop">
                              <img
                                src={course.course_image}
                                alt={course.course_name}
                                className="courseCardThumb"
                              />
                              <a className="courseCardMenu" href="#!">
                                <i className="fas fa-ellipsis-v" />
                              </a>
                            </div>
                            <h6 className="courseCardTitle">
                              {course.course_name}
                            </h6>
                            <div className="courseCardTeacher">
                              <img
                                src={course.teacher_image}
                                alt={course.course_teacher}
                                className="courseCardTeacherImg"
                              />
                              <span>{course.course_teacher}</span>
                            </div>
                            <div className="courseCardProgress">
                              <div className="courseCardProgressMeta">
                                <span>Progress</span>
                                <span>{course.complete_course_progress}%</span>
                              </div>
                              <div className="progress" style={{ height: 6 }}>
                                <div
                                  className="progress-bar bg-success"
                                  role="progressbar"
                                  style={{
                                    width:
                                      course.complete_course_progress + "%",
                                  }}
                                  aria-valuenow={course.complete_course_progress}
                                  aria-valuemin={0}
                                  aria-valuemax={100}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>

                  {/* Purchase history */}
                  <div className="sectionHeader">
                    <h6 className="sectionTitle">Purchase History</h6>
                    <div className="w-auto">
                      <select
                        className="form-select form-select-sm formCircle"
                        aria-label="Filter purchase history"
                      >
                        <option>All Time</option>
                        <option value={1}>Last month</option>
                        <option value={2}>Last 3 months</option>
                        <option value={3}>Last year</option>
                      </select>
                    </div>
                  </div>
                  <div className="historyCard">
                    <div className="table-responsive">
                      <table className="table historyTable align-middle mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Course</th>
                            <th className="text-end">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {!loading && order?.length === 0 && (
                            <tr>
                              <td colSpan={4} className="text-center py-4">
                                No purchases yet.
                              </td>
                            </tr>
                          )}
                          {!loading &&
                            order?.map((value, index) => (
                              <tr key={index}>
                                <th scope="row">{index + 1}</th>
                                <td>{value.order_date}</td>
                                <td>{value.course_name}</td>
                                <td className="text-end fw-semibold">
                                  {value.amount}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {/* Events */}
              <div className="col-12 col-md-3">
                <div className="dashboardEvent">
                  <h6 className="sectionTitle mb-3">Upcoming Events</h6>
                  <div className="eventImg">
                    {events.length === 0 && (
                      <div className="emptyState emptyState--sm">
                        <i className="far fa-calendar" />
                        <p>No upcoming events.</p>
                      </div>
                    )}
                    {events?.map((value, x) => (
                      <a href="#!" key={x} className="eventCard">
                        <img src={value.image} alt="" className="rounded" />
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </Fragment>
  );
}

export default Dashboard;
